import { render, staticRenderFns } from "./LimitProducts.vue?vue&type=template&id=4dbb718e&scoped=true"
import script from "./LimitProducts.vue?vue&type=script&lang=js"
export * from "./LimitProducts.vue?vue&type=script&lang=js"
import style0 from "./LimitProducts.vue?vue&type=style&index=0&id=4dbb718e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbb718e",
  null
  
)

export default component.exports